export const EMPTY_STATE_BANNER_IMAGE = "/images/activation/empty-project-banner.png";
